import React, { Component } from 'react';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
  Button,
  FormFeedback
} from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStore } from '../../store/storesActions';

class AddStore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validation: {}
    };
  }

  onChange(evt, what, transformValue = value => value) {
    this.setState({
      [what]: transformValue(evt.target.value)
    });
  }

  validate() {
    const validation = {};
    if (!this.state.id) {
      validation.id = 'ID is required';
    }
    if (!this.state.name) {
      validation.name = 'Name is required';
    }

    this.setState({
      validation
    });
    return Object.keys(validation).length === 0;
  }

  onCreateStore() {
    if (this.validate()) {
      this.props.createStore(this.state.id, this.state.name);
      this.onClose();
    }
  }

  onClose() {
    this.setState({
      id: '',
      name: '',
      validation: {}
    });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    const { id, name } = this.state;
    return (
      <Modal isOpen={this.props.show} toggle={this.props.onClose}>
        <ModalHeader>Create new store</ModalHeader>
        <ModalBody>
          <Form className="flex-form">
            <FormGroup>
              <Label for="addstore-store-id">
                Store ID*{' '}
                <small className="text-lighter">(Must be a unique value</small>
              </Label>

              <Input
                id="addstore-store-id"
                onChange={evt =>
                  this.onChange(evt, 'id', value =>
                    value.replace(/\s+/g, '-').toLowerCase()
                  )
                }
                invalid={Boolean(this.state.validation.id)}
              />
              <FormFeedback>{this.state.validation.id}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="addstore-store-name">Store name*</Label>
              <Input
                id="addstore-store-name"
                onChange={evt => {
                  this.onChange(evt, 'name');
                }}
                invalid={Boolean(this.state.validation.name)}
              />
              <FormFeedback>{this.state.validation.name}</FormFeedback>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color={'primary'}
            onClick={() => {
              this.onCreateStore();
            }}
            id="addstore-save"
            disabled={!name || !id}
          >
            Create store
          </Button>
          <Button
            color={'link'}
            onClick={() => {
              this.onClose();
            }}
            id="addstore-cancel"
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      createStore
    },
    dispatch
  );

export { AddStore };

export default connect(
  null,
  mapDispatchToProps
)(AddStore);



// WEBPACK FOOTER //
// ./src/components/AddStore/AddStore.js